import { render, staticRenderFns } from "./SidemenuIcon.vue?vue&type=template&id=6f517fa0"
import script from "./SidemenuIcon.vue?vue&type=script&lang=js"
export * from "./SidemenuIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports